export const YEAR_CASES = {
  nominative: ['год', 'года', 'лет'],
  genitive: ['года', 'лет', 'лет'],
}

export const MONTH_CASES = {
  nominative: ['месяц', 'месяца', 'месяцев'],
}
